<div class="modal">
  <div class="modal-content">
    <div class="modal-body" *ngIf="formGroup && documentConflict">
      <div class="modal-header">Conflit</div>

      <!-- Zone d'explication et de choix -->
      <div class="explication-wrapper" *ngIf="currentStep === 'stepOne'">
        Le fichier <span class="file-title">{{ documentConflict.documentTitre }} <span class="file-date">({{ formatDate(documentConflict.documentDate) }})</span></span> existe déjà
        <span *ngIf="!documentConflict.consultationTitre">.</span>
        <span *ngIf="documentConflict.consultationTitre"> pour la consultation {{ documentConflict.consultationTitre }}</span>
        <br>
        <br>
        <div>Que voulez-vous faire ?</div>
      </div>

      <!-- Zone de choix de nouveau titre -->
      <div class="new-title-input-wrapper" *ngIf="currentStep === 'stepTwo'">
        <frg-form-input
          id="newTitle"
          type="text"
          label="Nouveau titre du fichier"
          [formGroup]="formGroup"
          [control]="formGroup.get('newTitle')"
        ></frg-form-input>
      </div>

    </div>
    <div class="button-wrapper" *ngIf="formGroup && documentConflict && currentStep === 'stepOne'">
      <frg-button backgroundColor="var(--darkest-primary)" (activated)="renameFile()" fullWidth="true">Renommer le fichier</frg-button>
      <frg-button (activated)="overwriteFile()" fullWidth="true">Écraser le fichier existant</frg-button>
    </div>
    <div class="button-wrapper" *ngIf="formGroup && documentConflict && currentStep === 'stepTwo'">
        <frg-button (activated)="validNewTitle()" [disabled]="!formGroup.valid" fullWidth="true">Valider</frg-button>
    </div>
  </div>
</div>
<div class="modal-background"></div>